import axios from "axios";
import { waitlist } from "./getters";

export function fetchWaitlist({state, commit, rootState}) {
  const url = '/waitlist';

  return axios.get(url)
    .then(response => {
      const data = response.data.data.filter(item => item.user_id === rootState.auth.authUser._id && item.status === 'Active');
      const {authUser} = rootState.auth;

      commit('setWaitlist', {"data": data, "authUser": authUser});
      commit('updateIsWaitlistDataLoaded', data !== undefined);

      return data;
    })
    .catch(error => {
      commit('updateIsWaitlistDataLoaded', false);
      throw error;
    });
}

export async function joinWaitlist({commit}, payload) {
  const response = await axios.post("/waitlist", payload);
  commit("addToWaitlist", response.data.data);
}

export async function updateWaitlist({state, commit, rootState, dispatch}, payload) {
  let waitlistData = [];

  const slot = state.waitlistDropInCoachingSlot;

  if (state.waitlistDropInType === 'coaching_block') {
    waitlistData = state.waitlist.data.filter(item => item.user_id === rootState.auth.authUser._id && item.coaching_block_id === payload.coaching_block_id);
  } else if (state.waitlistDropInType === 'coaching_slot') {
    //waitlistData = state.waitlist.data.filter(item => item.user_id === rootState.auth.authUser._id && item.coaching_slot_id === slot.slots.block_slot_id);
    waitlistData = state.waitlist.data.filter(item => item.user_id === rootState.auth.authUser._id && (item.block_slot_id === slot.slots.block_slot_id || item.coaching_slot_id === slot.slots.track_id));
  }

  console.log('updateWaitlist', waitlistData, payload, slot, state.waitlistDropInType)
  const response = await axios.put(`/waitlist/${waitlistData[0]._id}`, payload).then(response => {
    dispatch('fetchWaitlist');
    return response.data.data;
  })
}
